import { addTranslations, setLocale, setRoute } from '@riva-mono/common';
import { PUBLIC_SUPABASE_ANON_KEY, PUBLIC_SUPABASE_URL } from '$env/static/public';
import { createBrowserClient, createServerClient, isBrowser } from '@supabase/ssr';
import type { LayoutLoad } from './$types';
import { env } from '$env/dynamic/public';
import { injectAnalytics } from '@vercel/analytics/sveltekit';
import { dev } from '$app/environment';

injectAnalytics({ mode: dev ? 'development' : 'production' });

export const load: LayoutLoad = async ({ fetch, data, depends, url }) => {
	depends('supabase:auth');
	// const { pathname } = url;
	// const protectedRoute = event.route.id?.indexOf('/questionnaire') !== -1;

	// TODO: Check if usesful, as it's done on hooks.server.ts
	// if (data.session === null && protectedRoute && event.route.id) {
	// 	return new Response(undefined, {
	// 		headers: { location: `/${event.params.lang}/login?from=${pathname}` },
	// 		status: 301
	// 	});
	// }

	const { i18n, translations } = data;
	const { lang, route } = i18n;

	addTranslations(translations);

	await setRoute(route);
	await setLocale(lang);

	const supabase = isBrowser()
		? createBrowserClient(PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY, {
				cookieOptions: {
					domain: env.PUBLIC_COOKIE_DOMAIN
				},
				global: {
					fetch
				}
			})
		: createServerClient(PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY, {
				cookieOptions: {
					domain: env.PUBLIC_COOKIE_DOMAIN
				},
				global: {
					fetch
				},
				cookies: {
					getAll() {
						return data.cookies;
					}
				}
			});

	const session = isBrowser() ? (await supabase.auth.getSession()).data.session : data.session;

	return { supabase, session: session, url: url.pathname, user: data.user };
};
